import { httpGet, httpPut } from './utils';

const api = {
  listSkuLowStockThreshold: httpGet,
  editSkuLowStockThreshold: httpPut,
};

export default api;
